import { render } from "./instagram.svg?vue&type=template&id=73597c66"
const script = {}
script.render = render

export default script